import { LazyBundleFactory } from '@core/core.types';

export const ChangeLocationFactory: LazyBundleFactory = () => import('./change-location.bundle');
